module.exports = __webpack_public_path__ + "app/components/wz/configuration-se.view.html";